<template>
  <div class="main">
    <vue-headful title="阀门备件包查询" description="阀门备件包查询" />
    <div class="header">
      <div class="left"></div>
      <div class="right"></div>
    </div>
    <div class="container">
      <div class="logo">
        <img src="../assets/spxflow-logo-2C.png" alt="SPX logos" />
      </div>
      <p class="desc">请在下方输入阀门编号，点击“提交”，即可查询APV™阀门备件包信息。</p>
      <div class="selects">
        <input type="text" v-model="keyword" class="text-input" />
        <div>
          <button class="submit" @click="search()" :disabled="keyword == ''">提交</button>
        </div>
      </div>
      <div class="results" v-if="Object.getOwnPropertyNames(valve).length > 1">
        <p>阀门描述</p>
        <p class="text">{{ valve.desc }}</p>
        <p>备件包号</p>
        <p class="text" v-if="valve.part_sn == '' || valve.part_sn == 'Please ask us'">请联系 SPX FLOW 售后工程师</p>
        <p class="text" v-else>{{ valve.part_sn }}</p>
        <div v-if="valve.part_desc != ''">
          <p>备件包描述</p>
          <p class="text">{{ valve.part_desc }}</p>
        </div>
      </div>
      <div v-else>
        <br />
        <br />
      </div>
    </div>
    <div class="footer">
      <img src="@/assets/footer.png" alt="" />
      <!-- <div class="top"></div>
      <div class="content">
        <div class="qr">
          <img src="@/assets/qr.jpeg" alt="" />
        </div>
        <div class="info">
          <h5>长按左侧二维码关注,了解更多</h5>
          <p>斯必克流体中国</p>
          <p>网址：spxflow.com/cn</p>
          <p>电话：86-21-2208 5888</p>
          <p>售后服务电话：4001-528-008</p>
          <p>邮箱：china.contact@spxflow.com</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { valveSearch } from "@/api/request";

export default {
  name: "search",
  data() {
    return {
      keyword: "",
      valve: {},
      types: [],
      models: [],
      sizes: [],
      materials: [],
      type: 0,
      model: 0,
      size: 0,
      material: 0,
      tools: [],
      parts: [],
    };
  },
  methods: {
    async search() {
      let loader = this.$loading.show({
        canCancel: true,
      });
      try {
        let data = await valveSearch({ keyword: this.keyword });
        if (data.valve == null) {
          Toast("没有找到该阀门");
          this.valve = {};
        } else {
          this.valve = data.valve;
        }
        loader.hide();
      } catch (error) {
        Toast(error);
        loader.hide();
      }
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 20px;
  text-align: center;
  box-sizing: border-box;
  min-height: calc(100vh - 206px);
  .logo {
    img {
      margin: 20px auto;
      width: 250px;
    }
  }
  .name {
    font-weight: 700;
    font-size: 18px;
    color: rgba(101, 99, 99, 1);
  }
  .desc {
    color: #656464;
    margin: 0px 24px 24px 24px;
    text-align: left;
    line-height: 32px;
  }
  .selects {
    padding: 0 24px;
    select {
      width: 100%;
      height: 46px;
      border: 1px solid rgba(79, 157, 73, 1);
      opacity: 0.7;
      background: #fff;
      border-radius: 20px 0px 20px 0px;
      margin-bottom: 17px;
      font-size: 17px;
      font-weight: normal;
      color: rgba(126, 124, 124, 1);
      line-height: 21px;
      padding-left: 10px;
    }
  }
}
.submit {
  margin-top: 12px;
  background: #1d4f48;
  color: #fff;
  border-radius: 21px;
  border: none;
  width: 129px;
  height: 43px;
  font-size: 17px;
  line-height: 43px;
  outline: none;
  &:active {
    background-color: #1d4f48;
    box-shadow: 0 1px #666;
    transform: translateY(1px);
  }

  &:active {
    outline: none;
  }
  &:disabled {
    background-color: #d7d7d7;
  }
}
.results {
  background-color: #f3f3f3;
  padding: 18px;
  margin: 30px 24px;
  border-radius: 5px;

  > p,
  > div > p {
    text-align: left;
    color: #1d4f48;
    line-height: 24px;
    margin: 0;
    margin-bottom: 0px;
    font-weight: 600;
  }
  .text {
    margin-bottom: 15px;
  }

  .result {
    text-align: left;
    background-color: #fff;
    padding: 16px;
    margin-bottom: 20px;
    .title {
      margin: 0px;
      margin-bottom: 10px;
    }
    .desc {
      margin: 0;
      font-size: 14px;
      font-weight: 400;
      color: rgba(101, 100, 100, 1);
      line-height: 23px;
    }
    img {
      margin-top: 10px;
      width: 100%;
    }
  }
}

select.active {
  color: #333 !important;
}

.text {
  color: rgba(101, 99, 99, 1) !important;
  text-align: left;
  font-weight: 500 !important;
}

.text-input {
  width: 90%;
  border: 1px solid #1d4f48;
  opacity: 0.7;
  background: #fff;
  border-radius: 20px 0px 20px 0px;
  line-height: 20px;
  outline: none;
  padding: 10px;
  font-size: 1rem;
}
</style>
